import { useMemo } from 'react';

import { useQuery } from '@apollo/client/react';

import type { Dictionaries_Types_Enum_Enum } from '@graphql/__generated__/graphql';
import { GET_DICTIONARY } from '@modules/_shared/components/dictionary-select/DictionarySelect';
import { getDictionaryLabels } from '@modules/_shared/utils/dictionaries';

export const useDictionaryLabels = (
  values: readonly string[] | null | undefined,
  dictionaryType: Dictionaries_Types_Enum_Enum,
) => {
  const { data, loading, error } = useQuery(GET_DICTIONARY, {
    variables: { type: dictionaryType },
    skip: !values?.length,
  });

  const labels = useMemo(
    () => getDictionaryLabels(values, data?.dictionaries),
    [data?.dictionaries, values],
  );

  return { labels, loading, error };
};
